import { mergePropertiesOfArrayOfObjectsWithIdKeys as merge, copyUnassignedProperites as copy } from './utils';
import { clearBasicAuth, END_SESSION, setRmiAuth } from './session';

const CLEAR_ERROR = 'KEYS::CLEAR_ERROR';

const GET_KEY_REQUEST_SENT = 'KEYS::GET_KEY_REQUEST_SENT';
const GET_KEY_REQUEST_SUCCESS = 'KEYS::GET_KEY_REQUEST_SUCCESS';
const GET_KEY_REQUEST_FAIL = 'KEYS::GET_KEY_REQUEST_FAIL';

const DELETE_KEY_REQUEST_SENT = 'KEYS::DELETE_KEY_REQUEST_SENT';
const DELETE_KEY_REQUEST_SUCCESS = 'KEYS::DELETE_KEY_REQUEST_SUCCESS';
const DELETE_KEY_REQUEST_FAIL = 'KEYS::DELETE_KEY_REQUEST_FAIL';

const KEY_AUTH_ACTION_SET = 'KEYS::KEY_AUTH_ACTION_SET';
const KEY_AUTH_OPEN = 'KEYS::KEY_AUTH_OPEN';
const KEY_AUTH_CLOSE = 'KEYS::KEY_AUTH_CLOSE';

const LIST_KEYS_REQUEST_SENT = 'KEYS::LIST_KEYS_REQUEST_SENT';
const LIST_KEYS_REQUEST_SUCCESS = 'KEYS::LIST_KEYS_REQUEST_SUCCESS';
const LIST_KEYS_REQUEST_FAIL = 'KEYS::LIST_KEYS_REQUEST_FAIL';

const POST_KEY_REQUEST_SENT = 'KEYS::POST_KEY_REQUEST_SENT';
const POST_KEY_REQUEST_SUCCESS = 'KEYS::POST_KEY_REQUEST_SUCCESS';
const POST_KEY_REQUEST_FAIL = 'KEYS::POST_KEY_REQUEST_FAIL';

const PUT_KEY_REQUEST_SENT = 'KEYS::PUT_KEY_REQUEST_SENT';
const PUT_KEY_REQUEST_SUCCESS = 'KEYS::PUT_KEY_REQUEST_SUCCESS';
const PUT_KEY_REQUEST_FAIL = 'KEYS::PUT_KEY_REQUEST_FAIL';

const UPDATE_KEY = 'KEYS::UPDATE_KEY';

const initialState = {
  error: undefined,
  deleteKeyRequestOut: false,
  getKeyRequestOut: false,
  keyAuthAction: '',
  keyAuthKey: {},
  keyAuthOpen: false,
  keys: [],
  listKeysRequestOut: false,
  postKeyRequestOut: false,
  putKeyRequestOut: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_ERROR:
      return { ...state, error: undefined };
    case DELETE_KEY_REQUEST_SENT:
      return { ...state, deleteKeyRequestOut: true, error: undefined };
    case DELETE_KEY_REQUEST_SUCCESS:
      return {
        ...state,
        keys: state.keys.filter(key => key.id !== action.id),
        deleteKeyRequestOut: false,
      };
    case DELETE_KEY_REQUEST_FAIL:
      return { ...state, error: action.error, deleteKeyRequestOut: false };
    case GET_KEY_REQUEST_SENT:
      return { ...state, getKeyRequestOut: true, error: undefined };
    case GET_KEY_REQUEST_SUCCESS: {
      const keys = state.keys
        .map(key => (key.id === action.key.id ? action.key : key));
      return { ...state, getKeyRequestOut: false, keys };
    }
    case GET_KEY_REQUEST_FAIL:
      return { ...state, getKeyRequestOut: false, error: action.error };
    case END_SESSION:
      return { ...initialState };
    case KEY_AUTH_ACTION_SET:
      return { ...state, keyAuthAction: action.action, keyAuthKey: action.key };
    case KEY_AUTH_OPEN:
      return { ...state, keyAuthOpen: true };
    case KEY_AUTH_CLOSE:
      return {
        ...state, keyAuthAction: '', keyAuthKey: {}, keyAuthOpen: false,
      };
    case LIST_KEYS_REQUEST_SENT:
      return { ...state, listKeysRequestOut: true, error: undefined };
    case LIST_KEYS_REQUEST_SUCCESS:
      return { ...state, keys: merge(state.keys, action.keys), listKeysRequestOut: false };
    case LIST_KEYS_REQUEST_FAIL:
      return { ...state, error: action.error, listKeysRequestOut: false };
    case POST_KEY_REQUEST_SENT:
      return { ...state, postKeyRequestOut: true, error: undefined };
    case POST_KEY_REQUEST_SUCCESS:
      return { ...state, postKeyRequestOut: false, keys: [action.key].concat(state.keys) };
    case POST_KEY_REQUEST_FAIL:
      return { ...state, postKeyRequestOut: false, error: action.error };
    case PUT_KEY_REQUEST_SENT:
      return { ...state, putKeyRequestOut: true, error: undefined };
    case PUT_KEY_REQUEST_SUCCESS: {
      const keys = state.keys
        .map(key => (key.id === action.key.id ? copy(key, action.key) : key));
      return { ...state, putKeyRequestOut: false, keys };
    }
    case PUT_KEY_REQUEST_FAIL:
      return { ...state, putKeyRequestOut: false, error: action.error };
    case UPDATE_KEY:
      return { ...state, keyAuthKey: action.key };
    default:
      return state;
  }
};

export const clearError = () => ({
  type: CLEAR_ERROR,
});

/*
 * List Keys Functions
 */
export const listKeys = () => (dispatch, getState) => {
  const { rmi } = getState();

  dispatch({ type: LIST_KEYS_REQUEST_SENT });
  return (
    rmi.keys.list()
      .then((keys) => {
        dispatch({ type: LIST_KEYS_REQUEST_SUCCESS, keys });
      })
      .catch((error) => {
        dispatch({ type: LIST_KEYS_REQUEST_FAIL, error });
      })
  );
};

/*
 * Get Key Functions
 */
export const getKey = config => (dispatch, getState) => {
  const { rmi } = getState();

  dispatch({ type: GET_KEY_REQUEST_SENT });
  return rmi.keys.get(config)
    .then((key) => {
      dispatch({ type: GET_KEY_REQUEST_SUCCESS, key });
    })
    .catch((error) => {
      dispatch({ type: GET_KEY_REQUEST_FAIL, error });
    });
};

/*
 * Post Key Functions
 */
export const postKey = config => (dispatch, getState) => {
  const { rmi } = getState();
  const { password } = config;
  config.name = config.name || ''; // eslint-disable-line no-param-reassign

  dispatch(setRmiAuth({ password }));
  dispatch({ type: POST_KEY_REQUEST_SENT });
  return rmi.keys.post(config)
    .then((key) => {
      dispatch({ type: POST_KEY_REQUEST_SUCCESS, key });
    })
    .catch((error) => {
      dispatch({ type: POST_KEY_REQUEST_FAIL, error });
    })
    .then(() => {
      dispatch(clearBasicAuth());
    });
};

/*
 * Put Key Functions
 */
export const putKey = config => (dispatch, getState) => {
  const { rmi } = getState();
  const { password } = config;

  dispatch(setRmiAuth({ password }));
  dispatch({ type: PUT_KEY_REQUEST_SENT });
  return rmi.keys.put(config)
    .then((key) => {
      dispatch({ type: PUT_KEY_REQUEST_SUCCESS, key });
    })
    .catch((error) => {
      dispatch({ type: PUT_KEY_REQUEST_FAIL, error });
    })
    .then(() => {
      dispatch(clearBasicAuth());
    });
};

/*
 * Delete Key Functions
 */
export const deleteKey = config => (dispatch, getState) => {
  const { rmi } = getState();
  const { password } = config;

  dispatch(setRmiAuth({ password }));
  dispatch({ type: DELETE_KEY_REQUEST_SENT });
  return rmi.keys.delete(config)
    .then(() => {
      dispatch({ type: DELETE_KEY_REQUEST_SUCCESS, id: config.id });
    })
    .catch((error) => {
      dispatch({ type: DELETE_KEY_REQUEST_FAIL, error });
    })
    .then(() => {
      dispatch(clearBasicAuth());
    });
};

export const renameKey = (newName, key) => {
  const updatedKey = { ...key, name: newName };

  return {
    type: UPDATE_KEY,
    key: updatedKey,
  };
};

/*
 * Key Auth Modal Actions
 */
export const setKeyAuthAction = (key, action) => ({
  type: KEY_AUTH_ACTION_SET,
  action,
  key,
});

export const openModal = () => ({
  type: KEY_AUTH_OPEN,
});

export const closeModal = () => ({
  type: KEY_AUTH_CLOSE,
});
